import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ImgProfileSkeleton from "../Skeleton/ProfileCompany/imgProfileSkeleton";
import imgDefault from '../../assets/imgEditPerfil/user.png';
import { InitialStateDepartment, InitialStateDistrito, InitialStateMunicipalities } from "../../Interfaces/departmentsAndmuniti";
import { SocialMedia, UpdatedInfoFreelancer } from "../../Interfaces/UpdatedInfoFreelancer";
import { ValidateEmail } from "../../function/Login";
import { alertLogin } from "../../Interfaces/Login";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Cookies from 'universal-cookie';
import { useNavigate, Link } from "react-router-dom";
import InputMask from 'react-input-mask';
import EditFreelancerSkeleton from "../Skeleton/ProfileFreelancer/editFreelancerSkeleton";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import IconLoading from '../iconLoading/IconLoading';
import mapboxgl, { FullscreenControl, GeolocateControl, Marker, NavigationControl } from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { differenceInYears } from "date-fns";
import { getProfileInfo, decryptData } from "../Utils/Utils";

registerLocale('es', es);

type handleInputChange = ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>

const initialStateUpdatedInfoFreelancer = {
    names: "",
    lastnames: "",
    email: "",
    birthDate: "",
    phone: "",
    phone_alternative: "",
    sexo: "",
    dui: "",
    nit: "",
    city: "",
    district_id: "",
    department: "",
    Distrito: "",
    billing: "",
    method_details: "",
    iva: "",
    iva_register: "",
    languages: "",
    direction: "",
    about_me: "",
    imagen1: "",
    imagen2: "",
    photo: "",
    id: "",
    facebook: 0,
    instagram: 0,
    twitter: 0,
    linkedin: 0,
    portfolio: '',
    otherLanguage: "",
    latitude: 13.69398964025628,
    longitude: -89.23642266136574,
    briefcase_link: '',
    schedules: "",
    parent: 0,
    job_avaible: 0,
    employment_type_interest: "",
    resume_file: "",
};

const initialStateInput = {
    input: "",
    message: '',
    state: false
}

const initialStateSocialMedia = {
    facebook: "",
    instagram: "",
    twitter: "",
    linkedin: ""
}

const initialStateLanguages = {
    name: "",
    id: 0 || ""
}

let checkedState: any = [];

const initialStateMunicipalities = {
    name: "",
    id: 0
}

const initialStateDistrito = {
    name: "",
    id: 0
}

const initialStatePatment = {
    created_at: "",
    id: "",
    name: "",
    status: "",
    updated_at: "",
}

const EditProfileFreelancer = () => {
    const [updatedInfo, setUpdatedInfo] = useState<UpdatedInfoFreelancer>(initialStateUpdatedInfoFreelancer);
    const [socialMedia, setSocialMedia] = useState<SocialMedia>(initialStateSocialMedia);
    const [departments, setDepartments] = useState<InitialStateDepartment[]>([]);
    const [departmentLoadError, setDepartmentLoadError] = useState("");
    const [municipalities, setMunicipalities] = useState<InitialStateMunicipalities[]>([initialStateMunicipalities]);
    const [Distrito, setDistrito] = useState<InitialStateDistrito[]>([initialStateDistrito]);
    const [paymentMethod, setPaymentMethod] = useState([initialStatePatment]);
    const [disabledInput, setDisabledInput] = useState(false);
    const [DUI, setDUI] = useState("");
    const [NIT, setNIT] = useState("");
    const [duiExist, setDuiExist] = useState(false);
    const [mostrarDui, setMostrarDui] = useState(false);
    const [mostrarNit, setMostrarNit] = useState(false);
    const [mostrarDuiConNit, setMostrarDuiConNit] = useState(false);
    const [billing, setBilling] = useState([
        { id: "CCFF", name: "Consumidor final" },
        { id: "CCF", name: "Comprobante de crédito fiscal" }
    ]);
    const [selectIva, setSelectIva] = useState([
        { id: 1, name: "Si" },
        { id: 0, name: "No" }
    ]);
    const [schedules, setSchedules] = useState([
        { id: 1, name: "Si" },
        { id: 2, name: "No" }
    ]);
    const [parent, setparent] = useState([
        { id: 1, name: "Si" },
        { id: 2, name: "No" }
    ]);
    const [employmentTypeOptions, setEmploymentTypeOptions] = useState<{ id: number, name: string }[]>([]);
    const [availabilityTypes, setAvailabilityTypes] = useState<{ id: number, name: string }[]>([]);
    const [Languages, setLanguages] = useState([initialStateLanguages]);
    const [MostrarImg, setMostrarImg] = useState<string | null>(imgDefault);
    const [imgOld, setImgOld] = useState<string | null>(imgDefault);
    const [closeImg, setCloseImg] = useState(false);
    const [loadImgProfile, setloadImgProfile] = useState(true);
    const [phone, setPhone] = React.useState<string>("");
    const [alert, setalert] = useState<alertLogin[]>([initialStateInput]);
    const MySwal = withReactContent(Swal);
    const [sendingData, setSendingData] = useState(false);
    const navigate = useNavigate();
    const cookies = new Cookies();
    const getSesion = cookies.get('Bearer');
    const [IsLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState("");
    // `billing` no existe en freelancer_profiles: el select de IVA dependía de esa columna
    // inexistente y quedaba deshabilitado para siempre (Reporte Chambaticon/TiconX §2).
    const [disabledInputIVA, setdisabledInputIVA] = useState(false);
    const [mensajeDeValidacion, setmensajeDeValidacion] = useState(false);
    let fileRefProfile = null;
    let fileRePortada = null;
    let backupLanguage = "";
    const [characterTextLength, setCharacterTextLength] = useState(250);
    const [lengthText, setLengthText] = useState(0);

    mapboxgl.accessToken = 'pk.eyJ1IjoiZ2Vvcmdlc3YiLCJhIjoiY2s5YTJjaGV0MDB0NzNsbXFuM3EyeThnYSJ9.F7uxDu4RAFlHz61e2cxNjw';

    const mapContainer = useRef<any>();
    const map = useRef<any>();
    const [lng, setLng] = useState(-88.9426);
    const [lat, setLat] = useState(13.8767);
    // El mapa se crea dentro de un setTimeout en un efecto de montaje ([] deps); su closure
    // captura la ubicación INICIAL para siempre, así que centrar/marcar con `updatedInfo` o
    // `lat`/`lng` de estado no refleja la ubicación guardada que carga después por API. Un ref
    // sí refleja el valor más reciente en ese momento (Reporte Chambaticon/TiconX §2).
    const latestLocation = useRef({ lat: 13.8767, lng: -88.9426 });
    const [zoom, setZoom] = useState(9);
    const [UbicacionMap, setUbicacionMap] = useState({
        lng: 0,
        lat: 0
    });
    const [CheckboxOtherLanguageIsChecked, setCheckboxOtherLanguageIsChecked] = useState(true);
    // Checkboxes de idiomas controlados por estado (Reporte Chambaticon/TiconX §2): antes se
    // premarcaban manipulando el DOM con document.getElementById dentro de un setTimeout, una
    // carrera contra el render de React que fallaba si los checkboxes aún no existían.
    const [selectedLanguages, setSelectedLanguages] = useState<string[]>([]);
    const [ExistOtherLanguage, SetExistOtherLanguage] = useState(false);
    const [habilitarOtherLanguage, setHabilitarOtherLanguages] = useState(false);

    function esMayorDeEdad(date: string) {
        if (!date) return false;

        const birthDate = new Date(date);
        if (Number.isNaN(birthDate.getTime())) return false;

        const today = new Date();
        const age = differenceInYears(today, birthDate);
        return age >= 18;
    }

    let checkboxOtherLanguage = document.getElementById("other") as HTMLInputElement || null;

    async function fetchData() {
        const idUser = cookies.get('Bearer');
        if (!idUser?.id) {
            setLoadError("No se encontró una sesión activa. Inicia sesión nuevamente para editar tu perfil.");
            setIsLoading(false);
            setloadImgProfile(false);
            return;
        }
        const urlProfileFreelancer = `${process.env.REACT_APP_API_URI}freelancer/profile/${idUser.id}`;
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'ApiToken': `Bearer ${getSesion.token}`
            }
        };
        try {
            const resp = await axios.get(urlProfileFreelancer, { ...config, timeout: 15000 });
            if (!resp.data?.data?.user) {
                throw new Error("La API no devolvió los datos del perfil.");
            }
            
            updatedInfo.names = resp.data.data.user.names;
            updatedInfo.lastnames = resp.data.data.user.lastnames;
            updatedInfo.email = resp.data.data.user.email;

            if (resp.data.data.about_me == "" || resp.data.data.about_me == null || resp.data.data.about_me == "null" || resp.data.data.about_me == " null") {
                updatedInfo.about_me = "";
            } else {
                updatedInfo.about_me = resp.data.data.about_me;
            };

            
            const decryptedDui = resp.data.data.dui ? decryptData(resp.data.data.dui) : '';
            const decryptedNit = resp.data.data.nit ? decryptData(resp.data.data.nit) : '';

            updatedInfo.direction = resp.data.data.direction;
            updatedInfo.dui = decryptedDui;
            updatedInfo.phone = resp.data.data.phone;
            updatedInfo.phone_alternative = resp.data.data.phone_alternative;
            // social_media_links puede venir vacío o con menos de 4 segmentos.
            const socialMediaLinks = Array.isArray(resp.data.data.social_media_links)
                ? resp.data.data.social_media_links
                : [];
            updatedInfo.facebook = socialMediaLinks[0] ?? "";
            updatedInfo.twitter = socialMediaLinks[1] ?? "";
            updatedInfo.linkedin = socialMediaLinks[2] ?? "";
            updatedInfo.instagram = socialMediaLinks[3] ?? "";
            updatedInfo.sexo = resp.data.data.gender;
            // Fallback para que el input de fecha sea controlado y la fecha viaje en el submit
            // (evita que el backend calcule edad 0 y pida NIT) — Reporte Chambaticon/TiconX §2.
            updatedInfo.birthDate = resp.data.data.birth_date ?? "";
            updatedInfo.briefcase_link = resp.data.data.briefcase_link;
            updatedInfo.schedules = resp.data.data.schedules;
            updatedInfo.parent = resp.data.data.parent;
            updatedInfo.job_avaible = resp.data.data.job_avaible;
            updatedInfo.employment_type_interest = Array.isArray(resp.data.data.employment_type_interest)
                ? resp.data.data.employment_type_interest.join(',')
                : "";

            if(resp.data.data.latitude && resp.data.data.longitude) {
                updatedInfo.latitude = resp.data.data.latitude;
                updatedInfo.longitude = resp.data.data.longitude;
                setUbicacionMap({
                    lat: resp.data.data.latitude,
                    lng: resp.data.data.longitude
                });
                setLat(resp.data.data.latitude);
                setLng(resp.data.data.longitude);
                latestLocation.current = { lat: resp.data.data.latitude, lng: resp.data.data.longitude };
            }

            if (resp.data.data.about_me != null) {
                setLengthText((resp.data.data.about_me).length);
            }

            (Array.isArray(resp.data.data.languages) ? resp.data.data.languages : []).map((otherLanguageMap: any) => {
                if (otherLanguageMap.id == "other") {
                    SetExistOtherLanguage(true);
                    updatedInfo.otherLanguage = otherLanguageMap.name;
                    backupLanguage = otherLanguageMap.name;
                }
            });

            if (resp.data.data.iva == 1) {
                updatedInfo.iva = resp.data.data.iva;
                setDisabledInput(true);
            }
            updatedInfo.billing = resp.data.data.billing;
            updatedInfo.iva_register = resp.data.data.iva_register;

            if (resp.data.data.billing == "CCF") {
                setdisabledInputIVA(true);
            } else if (resp.data.data.billing == "CCFF") {
                setdisabledInputIVA(false);
            };

            updatedInfo.iva = resp.data.data.iva;

            if (resp.data.data.iva === "1") {
                setDisabledInput(true);
            } else if (resp.data.data.iva === "0") {
                setDisabledInput(false);
            }

            if (resp.data.data.state?.id) getMunicipalities(resp.data.data.state.id);
            if (resp.data.data.city?.id) getDistrito(resp.data.data.city.id);

            if (decryptedDui !== '') {
                setDUI(decryptedDui);
            }

            if (decryptedNit !== '') {
                setNIT(decryptedNit);
            }

            if (decryptedDui !== '') {
                setDuiExist(true);
            }

            setMostrarDui(true);
            setMostrarNit(true);
            setMostrarDuiConNit(false);

            setIsLoading(false);
            setloadImgProfile(false);
            try {
                const responsePhoto = await getProfileInfo("dui", decryptedDui, resp.data.data.client_company_id);
                setMostrarImg(responsePhoto || imgDefault);
                setImgOld(responsePhoto || imgDefault);
            } catch (error) {
                console.error("No se pudo cargar la foto del perfil:", error);
                setMostrarImg(imgDefault);
                setImgOld(imgDefault);
            }

            setTimeout(() => {
                const departmentVALUE = document.getElementById('departmentvalue',) as HTMLInputElement | null;
                const cityId = document.getElementById('cityId',) as HTMLInputElement | null;
                if (departmentVALUE != undefined && resp.data.data.state?.id) {
                    departmentVALUE.value = resp.data.data.state.id;
                    updatedInfo.department = resp.data.data.state.id;
                };
                if (cityId != undefined && resp.data.data.city?.id) {
                    cityId.value = resp.data.data.city.id;
                    updatedInfo.city = resp.data.data.city.id;
                    // El backend ya no expone district_id en la raíz (se quita por privacidad
                    // del perfil público); el id ahora viene en el objeto district.
                    updatedInfo.district_id = resp.data.data.district?.id ?? "";
                }
                if (resp.data.data.languages) {
                    checkedState = resp.data.data.languages.map((item: any) => String(item.id));
                    setSelectedLanguages(Array.from(new Set(checkedState)));
                } else {
                    checkedState = [];
                    setSelectedLanguages([]);
                }
            }, 1500);

        } catch (err) {
            console.error("No se pudo cargar el perfil del talento:", err);
            setLoadError("No se pudo cargar tu perfil. Verifica la conexión con la API e inténtalo nuevamente.");
            setIsLoading(false);
            setloadImgProfile(false);
        }
    };

    async function getPaymentMethod() {
        const urlCountry = `${process.env.REACT_APP_API_URI}freelancer/payment-method`;
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'ApiToken': `Bearer ${getSesion.token}`
            }
        };
        try {
            const resp = await axios.get(urlCountry, config);
            setPaymentMethod(resp.data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchData();
        getPaymentMethod();
    }, []);

    const handleInputChange = ({ target: { name, value, id, } }: handleInputChange) => {
        if (name == 'about_me') {
            setLengthText(value.length);
            if (value.length >= 500) {
                setLengthText(500);
                setUpdatedInfo({ ...updatedInfo, [name]: value.substring(0, 500) });
            } else {
                setUpdatedInfo({ ...updatedInfo, [name]: value });
            }
        } else {
            if (name == 'phone_alternative' || name == 'phone' || name == 'dui') setPhone(value);

            if (name == "dui") {
                setDUI(value);
            }

            if (name == "nit") {
                setNIT(value);
            }

            if (name === "department") getMunicipalities(value);
            if (name === "city") getDistrito(value);

            if (name === "iva") {
                if (value === "1") { setDisabledInput(true); } else if (value === "0") { setDisabledInput(false); }
            }
            if (value == "CCF") {
                setdisabledInputIVA(true);
                updatedInfo.iva = "1";
                setDisabledInput(true);
            } else if (value == "CCFF") {
                setdisabledInputIVA(false);
                updatedInfo.iva = "0";
                setDisabledInput(false);
            }
            setUpdatedInfo({ ...updatedInfo, [name]: value });
        }
    };

    // Solicitud del cliente: tipo(s) de empleo de interés — multiselección sobre checkboxes,
    // guardada como string separado por comas (mismo formato que envía el backend).
    const handleEmploymentTypeToggle = (typeId: number) => {
        const current = updatedInfo.employment_type_interest
            ? updatedInfo.employment_type_interest.split(',').filter(Boolean)
            : [];
        const idStr = String(typeId);
        const next = current.includes(idStr)
            ? current.filter((value) => value !== idStr)
            : [...current, idStr];

        setUpdatedInfo({ ...updatedInfo, employment_type_interest: next.join(',') });
    };

    const handleInputChangelanguages = ({ target: { name, value, id, } }: handleInputChange) => {
        const checkbox = document.getElementById(id,) as HTMLInputElement | null;

        if (checkbox?.id == "other") {
            if (!checkbox?.checked) {
                setCheckboxOtherLanguageIsChecked(false);
            } else {
                setCheckboxOtherLanguageIsChecked(true);
            }
        }

        if (checkbox?.id == "language10") {
            if (!checkbox?.checked) {
                setCheckboxOtherLanguageIsChecked(false);
            } else {
                setCheckboxOtherLanguageIsChecked(true);
            }
        }
        if (checkbox?.checked) {
            checkedState.push(value);
        } else {
            checkedState.map((infoArray: string, index: number) => {
                if (infoArray === value) {
                    checkedState.splice(index, 1);
                }
            });
        }
        setSelectedLanguages(Array.from(new Set(checkedState)));
    };

    const handleUpdatedInfoValidate = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!disabledInput) {
            updatedInfo.iva_register = "";
        };

        const formatDocument = (value: string, groups: number[]): string => {
            const digits = value.replace(/\D/g, "");
            if (digits.length !== groups.reduce((total, group) => total + group, 0)) {
                return value;
            }

            let offset = 0;
            return groups.map((group) => {
                const part = digits.slice(offset, offset + group);
                offset += group;
                return part;
            }).join("-");
        };
        const duiValue = formatDocument(DUI, [8, 1]);
        const nitValue = formatDocument(NIT, [4, 6, 3, 1]);

        let verifyValues = [
            { name: "name", value: updatedInfo.names },
            { name: "lastnames", value: updatedInfo.lastnames },
            { name: "gmail", value: updatedInfo.email },
            { name: "dateOfBirth", value: updatedInfo.birthDate },
            { name: "tel", value: updatedInfo.phone },
            { name: "sex", value: updatedInfo.sexo },
            { name: "country", value: updatedInfo.city },
            { name: "department", value: updatedInfo.department },
            { name: "distrito", value: updatedInfo.district_id },
            { name: "language", value: checkedState.length },
            { name: "address", value: updatedInfo.direction },
            { name: "description", value: updatedInfo.about_me },
            { name: "otherLanguage", value: updatedInfo.otherLanguage },
            { name: "iva", value: updatedInfo.iva },
            { name: "schedules", value: updatedInfo.schedules },
            { name: "parent", value: updatedInfo.parent }
        ];

        if (esMayorDeEdad(updatedInfo.birthDate)) {
            verifyValues.push({ name: "dui", value: duiValue });
        } else if (mostrarNit) {
            verifyValues.push({ name: "nit", value: nitValue });
        }

        const validateInputs = ValidateEmail(verifyValues);
        setalert(validateInputs);
        updatedInfo.id = getSesion.id;

        // LinkedIn es opcional (revisión con CONEXIÓN, oct-2026): ni al crear el perfil ni al editarlo.

        if (updatedInfo.imagen1 == "") {
            delete updatedInfo.imagen1
        }
        if (updatedInfo.imagen2 == "") {
            delete updatedInfo.imagen2
        }
        updatedInfo.latitude = UbicacionMap.lat;
        updatedInfo.longitude = UbicacionMap.lng;
        // Se reemplazó el número mágico (state.length >= 16, que nunca se alcanzaba porque
        // "otherLanguage" no tiene case en ValidateEmail) por una compuerta basada en si hay
        // errores reales (Reporte Chambaticon/TiconX §2).
        const hasErrors = validateInputs.some(input => input.state === true);
        setmensajeDeValidacion(hasErrors);
        if (Number(updatedInfo.iva) == 1) {
            if (updatedInfo.iva_register == "" || updatedInfo.iva_register == null || updatedInfo.iva_register == undefined) {
                MySwal.fire({
                    position: 'center',
                    icon: 'error',
                    title: "Registro de IVA requerido",
                    showConfirmButton: false,
                    timer: 5500
                });
            } else if (!hasErrors) {
                sendData(duiValue, nitValue);
            }
        } else {
            if (!hasErrors) sendData(duiValue, nitValue);
        }
    };

    function sendData(dui: string, nit: string) {
        if (CheckboxOtherLanguageIsChecked == false) {
            updatedInfo.otherLanguage = "";
        }
        setSendingData(true);
        const url = `${process.env.REACT_APP_API_URI}freelancer/complete-profile/${getSesion.id}`;
        // No se fija 'Content-Type' aquí: con FormData, axios/el navegador deben generarlo
        // ellos mismos para incluir el boundary del multipart (Reporte Chambaticon/TiconX §2).
        let config = {
            headers: {
                'Accept': 'application/json',
                'ApiToken': `Bearer ${getSesion.token}`
            }
        }

        const objectNew = { ...updatedInfo, dui, nit };

        if (objectNew.imagen2 === imgDefault || objectNew.imagen2 === null || objectNew.imagen2 === undefined) {
            delete objectNew.imagen2;
        }

        // FormData real: con axios 0.27, un objeto plano se serializa como JSON y los File se
        // pierden ($request->hasFile('imagen1') siempre falso en el backend) — Reporte
        // Chambaticon/TiconX §2.
        const formData = new FormData();
        Object.entries(objectNew).forEach(([key, value]) => {
            if (value === null || value === undefined) return;
            formData.append(key, value as string | Blob);
        });

        axios.post(url, formData, config)
            .then(response => {
                MySwal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3500
                }).then(() => {
                    sendDataLegn();
                    setUpdatedInfo(initialStateUpdatedInfoFreelancer);
                    setDepartments([]);
                    setSocialMedia(initialStateSocialMedia);
                    setSendingData(false);
                    navigate('/perfil-freelancer');
                });
            })
            .catch(err => {
                MySwal.fire({
                    position: 'center',
                    icon: 'error',
                    title: err.response.data.message,
                    showConfirmButton: false,
                    timer: 5500
                });
                setSendingData(false);
            })
    };

    const sendDataLegn = () => {
        const url2 = `${process.env.REACT_APP_API_URI}freelancer/update-languages/${getSesion.id}`;
        let config2 = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'ApiToken': `Bearer ${getSesion.token}`
            }
        }
        axios.post(url2, { languagesAry: checkedState }, config2)
            .then(response => {
                checkedState = "";
            })
            .catch(err => {
                console.log(err.response);
            })
    }

    const reverseImg = () => {
        setloadImgProfile(true);
        setMostrarImg(imgOld);
        setCloseImg(false);
        setTimeout(() => {
            setloadImgProfile(false);
        }, 1000);
    }

    // El input de foto de PERFIL (id="photo") usaba uploadProfilePortada, que asigna a
    // imagen2 (portada) y no actualiza la previsualización. Se separa en su propio handler:
    // setea imagen1 + MostrarImg + closeImg (Reporte Chambaticon/TiconX §2).
    const uploadProfilePhoto = (e: { target: { files: any; value: string } }) => {
        let files = e.target.files;
        if (!files || files.length === 0) return;

        let image = files[0];

        if (!image.type.startsWith("image/")) {
            MySwal.fire({
                position: 'center',
                icon: 'error',
                title: "Por favor, sube un archivo de imagen válido.",
                showConfirmButton: false,
                timer: 3500
            });

            e.target.value = "";
            return;
        }

        fileRefProfile = image;
        updatedInfo.imagen1 = fileRefProfile;
        setMostrarImg(URL.createObjectURL(image));
        setCloseImg(true);
    };

    const uploadProfilePortada = (e: { target: { files: any; value: string } }) => {
        let files = e.target.files;
        if (!files || files.length === 0) return;
    
        let image = files[0];
    
        if (!image.type.startsWith("image/")) {
            MySwal.fire({
                position: 'center',
                icon: 'error',
                title: "Por favor, sube un archivo de imagen válido.",
                showConfirmButton: false,
                timer: 3500
            });
    
            e.target.value = "";
            return;
        }
    
        fileRePortada = image;
        let imageUrl = URL.createObjectURL(image);
        updatedInfo.imagen2 = fileRePortada;
    };

    async function getMunicipalities(id: string) {
        try {
            const urlCity = `${process.env.REACT_APP_API_URI}city/${id}`;
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };
            const resp = await axios.get(urlCity, config);
            setMunicipalities(resp.data);
        } catch (err) {
            console.error(err);
        }
    };

    async function getDistrito(id: string) {
        try {
            const urlCity = `${process.env.REACT_APP_API_URI}district/${id}`;
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };
            const resp = await axios.get(urlCity, config);
            setDistrito(resp.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        async function getState() {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };
            try {
                const countriesResponse = await axios.get(
                    `${process.env.REACT_APP_API_URI}country/`,
                    config
                );
                const countries = Array.isArray(countriesResponse.data)
                    ? countriesResponse.data
                    : [];
                const elSalvador = countries.find((country) =>
                    Number(country.code) === 503 ||
                    country.name?.trim().toLowerCase() === "el salvador"
                );

                if (!elSalvador) {
                    throw new Error("No se encontró El Salvador en el catálogo de países.");
                }

                const statesResponse = await axios.get(
                    `${process.env.REACT_APP_API_URI}state/${elSalvador.id}`,
                    config
                );
                if (!Array.isArray(statesResponse.data)) {
                    throw new Error("No hay departamentos disponibles para El Salvador.");
                }

                setDepartments(statesResponse.data);
                setDepartmentLoadError(
                    statesResponse.data.length === 0
                        ? "No hay departamentos registrados para El Salvador."
                        : ""
                );
            } catch (err) {
                console.error(err);
                setDepartments([]);
                setDepartmentLoadError("No se pudieron cargar los departamentos.");
            }
        };
        getState();

        async function getLanguages() {
            const urlCountry = `${process.env.REACT_APP_API_URI}freelancer/get/languages`;
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };
            try {
                const resp = await axios.get(urlCountry, config);
                setLanguages(Array.isArray(resp.data?.log) ? resp.data.log : []);
            } catch (err) {
                console.error(err);
                setLanguages([]);
            }
        };
        getLanguages();

        // Solicitud del cliente: tipo(s) de trabajo que el talento está dispuesto a aceptar
        // (Voluntariado/Pasantía remunerada/Pasantía no remunerada/Trabajo de tiempo completo/
        // Trabajo de medio tiempo/Proyecto o consultoría/Emprendimiento).
        async function getWorkTypeInterests() {
            const urlCountry = `${process.env.REACT_APP_API_URI}freelancer/list/work-type-interests`;
            try {
                const resp = await axios.get(urlCountry);
                setEmploymentTypeOptions(Array.isArray(resp.data?.data) ? resp.data.data : []);
            } catch (err) {
                console.error(err);
                setEmploymentTypeOptions([]);
            }
        };
        getWorkTypeInterests();

        // Solicitud del cliente: la disponibilidad deja de ser Sí/No y pasa a distinguir la
        // modalidad (Disponibilidad inmediata/Tiempo completo/Medio tiempo/Por horas/No
        // disponible) — catálogo público, no requiere sesión.
        async function getAvailabilityTypes() {
            const urlCountry = `${process.env.REACT_APP_API_URI}freelancer/list/availability-types`;
            try {
                const resp = await axios.get(urlCountry);
                setAvailabilityTypes(Array.isArray(resp.data?.data) ? resp.data.data : []);
            } catch (err) {
                console.error(err);
                setAvailabilityTypes([]);
            }
        };
        getAvailabilityTypes();
    }, []);

    useEffect(() => {
        const mapTimeout = window.setTimeout(() => {
            const container = mapContainer.current;
            if (!container) return;

            try {
                map.current = new mapboxgl.Map({
                    container,
                    style: 'mapbox://styles/mapbox/streets-v12',
                    center: [latestLocation.current.lng, latestLocation.current.lat],
                    zoom: zoom,
                    minZoom: 2,
                    maxZoom: 24
                });

                new mapboxgl.Marker()
                    .setLngLat([latestLocation.current.lng, latestLocation.current.lat])
                    .addTo(map.current);

                const geocoder = new MapboxGeocoder({
                accessToken: "pk.eyJ1IjoiZ2Vvcmdlc3YiLCJhIjoiY2s5YTJjaGV0MDB0NzNsbXFuM3EyeThnYSJ9.F7uxDu4RAFlHz61e2cxNjw",
                countries: 'sv',
                bbox: [-90.0955545723, 13.1490168319, -87.7235029772, 14.4241327987],
                filter: (item: any) => {
                    return item.context.map((i: { id: string; text: string; }) => {
                        return (i.id.split('.').shift() === 'country' && i.text === 'El Salvador');
                    }).reduce((acc: any, cur: any) => {
                        return acc || cur;
                    });
                },
                placeholder: "Buscar",
            });

            const locateU = new GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            });

            let marker: { remove: () => void; };

            map.current.on('click', (e: { lngLat: { lng: number; lat: number; }; }) => {
                setUbicacionMap({
                    lng: e.lngLat.lng,
                    lat: e.lngLat.lat
                });
                // Actualización funcional (Reporte Chambaticon/TiconX §2): este handler se
                // registra una sola vez al montar, así que `updatedInfo` capturado por closure
                // sigue siendo el estado inicial vacío — spreadearlo aquí borraría el resto de
                // campos ya cargados/tecleados.
                setUpdatedInfo(prev => ({
                    ...prev,
                    longitude: e.lngLat.lng,
                    latitude: e.lngLat.lat
                }));

                if (typeof marker == 'object') {
                    marker.remove();
                }
                marker = new Marker().setLngLat([e.lngLat.lng, e.lngLat.lat]).addTo(map.current);
                map.current.flyTo({
                    center: e.lngLat,
                    zoom: 15
                });
            });

            geocoder.on('result', (ev: any) => {
                setUbicacionMap({
                    lng: ev.result.geometry.coordinates[0],
                    lat: ev.result.geometry.coordinates[1]
                });
                setUpdatedInfo(prev => ({
                    ...prev,
                    longitude: ev.result.geometry.coordinates[0],
                    latitude: ev.result.geometry.coordinates[1]
                }));
            });
            
            locateU.on('geolocate', (e: any) => {
                let lon = e.coords.longitude;
                let lat = e.coords.latitude;
                let position = [lon, lat];

                setUbicacionMap({
                    lng: lon,
                    lat: lat
                });
                setUpdatedInfo(prev => ({
                    ...prev,
                    longitude: lon,
                    latitude: lat
                }));

                map.current.flyTo({
                    center: position,
                    zoom: 9
                });
            });
            
                map.current.addControl(geocoder);
                map.current.addControl(new NavigationControl());
                map.current.addControl(new FullscreenControl());
                map.current.addControl(locateU);
            } catch (error) {
                console.error("No se pudo inicializar el mapa de ubicación:", error);
            }
        }, 3500);

        return () => {
            window.clearTimeout(mapTimeout);
            map.current?.remove();
            map.current = null;
        };
    }, []);

    return (
        <>
            {IsLoading && <EditFreelancerSkeleton />}
            {!IsLoading &&
                <div className="min-h-screen">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
                        {loadError && (
                            <div className="mb-6 rounded-lg border border-red-400 bg-red-100 px-4 py-3 text-red-700">
                                {loadError}
                            </div>
                        )}
                        {/* Botón de retroceso */}
                        <button
                            onClick={() => window.history.go(-1)} 
                            className="flex items-center text-white hover:text-Yellow transition-colors mb-6"
                        >
                            <FontAwesomeIcon icon={faArrowLeft} className="w-6 h-6 mr-2" />
                            <span className="text-lg font-medium">Volver</span>
                        </button>

                        <form onSubmit={handleUpdatedInfoValidate} className="rounded-lg overflow-hidden">
                            {/* Encabezado */}
                            <div className="px-6 py-4">
                                <h2 className="text-2xl md:text-3xl font-bold text-Yellow text-center w-full">
                                    Editar perfil de freelancer
                                </h2>
                            </div>

                            <div className="p-6 md:p-8 flex flex-col md:flex-row gap-8">
                                {/* Sección de imagen de perfil */}
                                <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                                    <div className="relative mb-4">
                                        {closeImg && (
                                            <button 
                                                className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-md z-10 hover:bg-gray-100"
                                                onClick={reverseImg}
                                            >
                                                <FontAwesomeIcon icon={faX} className="text-red-600 w-4 h-4" />
                                            </button>
                                        )}
                                        <label htmlFor="photo" className="cursor-pointer">
                                            {loadImgProfile ? (
                                                <ImgProfileSkeleton />
                                            ) : (
                                                <div className="relative group">
                                                    <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-Yellow">
                                                        <img 
                                                            className="w-full h-full object-cover" 
                                                            src={MostrarImg || imgDefault} 
                                                            alt="Imagen de perfil" 
                                                        />
                                                    </div>
                                                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                                        <span className="text-white font-medium">Editar foto</span>
                                                    </div>
                                                </div>
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            className="hidden"
                                            id="photo"
                                            onChange={uploadProfilePhoto}
                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className="block text-white font-medium mb-2">
                                            Foto de portada
                                        </label>
                                        <input 
                                            type="file" 
                                            className="w-full text-white text-sm bg-sky-700 hover:bg-sky-600 rounded-full py-2 px-4"
                                            onChange={uploadProfilePortada}
                                        />
                                    </div>
                                </div>

                                {/* Sección de formulario */}
                                <div className="w-full md:w-2/3 lg:w-3/4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Nombre */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Nombre*
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="names"
                                                value={updatedInfo.names}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "name" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Apellido */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Apellido*
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="lastnames"
                                                value={updatedInfo.lastnames}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "lastnames" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Correo electrónico */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Correo electrónico*
                                            </label>
                                            <input
                                                type="email"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="email"
                                                value={updatedInfo.email}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "gmail" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Fecha de nacimiento */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Fecha de nacimiento*
                                            </label>
                                            <input
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="birthDate"
                                                value={updatedInfo.birthDate}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "dateOfBirth" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Teléfono principal */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Teléfono principal*
                                            </label>
                                            <InputMask
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                mask={phone !== "" ? "9999-9999" : ""}
                                                placeholder="0000-0000"
                                                name="phone"
                                                value={updatedInfo.phone}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "tel" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Teléfono secundario */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Teléfono secundario
                                            </label>
                                            <InputMask
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                mask={phone !== "" ? "9999-9999" : ""}
                                                placeholder="0000-0000"
                                                name="phone_alternative"
                                                value={updatedInfo.phone_alternative}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Departamento */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Departamento*
                                            </label>
                                            <select
                                                name="department"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                onChange={handleInputChange}
                                                id="departmentvalue"
                                                value={updatedInfo.department}
                                            >
                                                <option value="">Seleccione un departamento</option>
                                                {departments.map((department) => (
                                                    <option key={department.id} value={department.id}>
                                                        {department.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "department" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                            {departmentLoadError && (
                                                <p className="text-red-500 text-sm mt-1">{departmentLoadError}</p>
                                            )}
                                        </div>

                                        {/* Municipio */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Municipio*
                                            </label>
                                            <select
                                                name="city"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                id="cityId"
                                                value={updatedInfo.city}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecciona tu Municipio</option>
                                                {municipalities.map((city) => (
                                                    <option key={city.id} value={city.id}>
                                                        {city.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "city" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Distrito */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Distrito*
                                            </label>
                                            <select
                                                name="district_id"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                id="district_id"
                                                value={updatedInfo.district_id}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecciona tu distrito</option>
                                                {Distrito.map((distrito) => (
                                                    <option key={distrito.id} value={distrito.id}>
                                                        {distrito.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "distrito" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Sexo */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Sexo*
                                            </label>
                                            <select
                                                name="sexo"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                value={updatedInfo.sexo}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" hidden>Seleccione...</option>
                                                <option value="2">Mujer</option>
                                                <option value="1">Hombre</option>
                                                <option value="3">Prefiero no decirlo</option>
                                            </select>
                                            {alert.filter(input => input.input == "sex" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Ambos documentos son visibles; la edad determina cuál es obligatorio. */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                DUI{esMayorDeEdad(updatedInfo.birthDate) ? "*" : ""}
                                            </label>
                                            <InputMask
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                mask={"99999999-9"}
                                                placeholder="00000000-0"
                                                name="dui"
                                                value={DUI}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "dui" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                NIT{!esMayorDeEdad(updatedInfo.birthDate) ? "*" : ""}
                                            </label>
                                            <InputMask
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                mask={"9999-999999-999-9"}
                                                placeholder="0000-000000-000-0"
                                                name="nit"
                                                value={NIT}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "nit" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* IVA */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                IVA*
                                            </label>
                                            <select
                                                name="iva"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                id="ivaId"
                                                value={updatedInfo.iva}
                                                onChange={handleInputChange}
                                                disabled={disabledInputIVA}
                                            >
                                                <option value="001">Seleccione una opción</option>
                                                {selectIva.map((iva) => (
                                                    <option key={iva.id} value={iva.id}>
                                                        {iva.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "iva" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Registro de IVA */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Registro de IVA*
                                            </label>
                                            <input
                                                type="text"
                                                className={`w-full px-4 py-2 border ${disabledInput ? 'border-gray-300' : 'border-gray-800'} rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent`}
                                                name="iva_register"
                                                value={updatedInfo.iva_register}
                                                onChange={handleInputChange}
                                                disabled={!disabledInput}
                                            />
                                            {alert.filter(input => input.input == "iva_register" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Horario rotatorio */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Horario rotatorio*
                                            </label>
                                            <select
                                                name="schedules"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                id="schedulesId"
                                                value={updatedInfo.schedules}
                                                onChange={handleInputChange}
                                            >
                                                <option value="001">Seleccione una opción</option>
                                                {schedules.map((horarios) => (
                                                    <option key={horarios.id} value={horarios.id}>
                                                        {horarios.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "schedules" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Padre/Madre de familia */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                ¿Es padre o madre de familia?*
                                            </label>
                                            <select
                                                name="parent"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                id="fatherOrMotherId"
                                                value={updatedInfo.parent}
                                                onChange={handleInputChange}
                                            >
                                                <option value="001">Seleccione una opción</option>
                                                {parent.map((parent) => (
                                                    <option key={parent.id} value={parent.id}>
                                                        {parent.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "parent" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Búsqueda de trabajo y disponibilidad */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                ¿Estás buscando trabajo?*
                                            </label>
                                            <select
                                                name="job_avaible"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                id="jobAvaible"
                                                value={updatedInfo.job_avaible}
                                                onChange={handleInputChange}
                                            >
                                                <option value="001">Seleccione una opción</option>
                                                {availabilityTypes.map((type) => (
                                                    <option key={type.id} value={type.id}>{type.name}</option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "job_avaible" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Modalidades de trabajo aceptadas */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                ¿Qué tipo de trabajo estás dispuesto a aceptar?
                                            </label>
                                            <div className="flex flex-wrap gap-x-6 gap-y-2">
                                                {employmentTypeOptions.map((type) => (
                                                    <label key={type.id} className="flex items-center gap-2 text-white font-normal cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            checked={updatedInfo.employment_type_interest.split(',').includes(String(type.id))}
                                                            onChange={() => handleEmploymentTypeToggle(type.id)}
                                                        />
                                                        {type.name}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Dirección */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Dirección*
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="direction"
                                                value={updatedInfo.direction}
                                                onChange={handleInputChange}
                                            />
                                            {alert.filter(input => input.input == "address" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Mapa */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-2">
                                                Ubicación en el mapa
                                            </label>
                                            <div 
                                                ref={mapContainer} 
                                                className="map-container h-64 w-full rounded-lg border border-gray-300 overflow-hidden"
                                            />
                                            <p className="text-sm text-gray-500 mt-2">
                                                Haz clic en el mapa para seleccionar la ubicación exacta
                                            </p>
                                        </div>

                                        {/* Acerca de ti */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Acerca de ti*
                                            </label>
                                            <textarea
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent h-40"
                                                name="about_me"
                                                value={updatedInfo.about_me}
                                                onChange={handleInputChange}
                                            />
                                            <div className="flex justify-between mt-1">
                                                <span className="text-sm text-gray-500">
                                                    {lengthText} / {characterTextLength} caracteres
                                                </span>
                                                {alert.filter(input => input.input == "description" && input.state === true).map((message, index) => (
                                                    <span key={index} className="text-red-500 text-sm">{message.message}</span>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Idiomas */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Idiomas que domino*
                                            </label>
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                                                {Languages.map((item) => (
                                                    <div key={item.id} className="flex items-center">
                                                        <input
                                                            className="w-4 h-4 mr-2 text-Yellow bg-gray-100 border-gray-300 rounded focus:ring-Yellow"
                                                            type="checkbox"
                                                            id={'language' + item.id}
                                                            name="languages"
                                                            onChange={handleInputChangelanguages}
                                                            value={item.id}
                                                            checked={selectedLanguages.includes(String(item.id))}
                                                        />
                                                        <label htmlFor={'language' + item.id} className="text-white">
                                                            {item.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            {alert.filter(input => input.input == "language" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}

                                            {(habilitarOtherLanguage || (ExistOtherLanguage && CheckboxOtherLanguageIsChecked)) && (
                                                <div className="mt-4">
                                                    <label className="block text-white font-medium mb-1">
                                                        {ExistOtherLanguage ? "Editar idioma agregado" : "Otro idioma"}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                        name="otherLanguage"
                                                        value={updatedInfo.otherLanguage}
                                                        onChange={handleInputChange}
                                                    />
                                                    {alert.filter(input => input.input == "otherLanguage" && input.state === true).map((message, index) => (
                                                        <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {/* Redes sociales */}
                                        <div className="col-span-1 md:col-span-2 mt-8">
                                            <div className="flex items-center my-6">
                                                <div className="flex-1 border-t border-Yellow"></div>
                                                <span className="px-4 text-Yellow font-medium">Redes sociales (opcionales)</span>
                                                <div className="flex-1 border-t border-Yellow"></div>
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                {/* Facebook */}
                                                <div>
                                                    <label className="block text-white font-medium mb-1">
                                                        Facebook
                                                    </label>
                                                    <div className="flex">
                                                        <span className="bg-blue-600 text-white px-3 py-2 rounded-l-lg flex items-center">
                                                            fb.com/
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="flex-1 px-4 py-2 rounded-r-lg"
                                                            name="facebook"
                                                            value={updatedInfo.facebook}
                                                            onChange={handleInputChange}
                                                            placeholder="usuario"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Instagram */}
                                                <div>
                                                    <label className="block text-white font-medium mb-1">
                                                        Instagram
                                                    </label>
                                                    <div className="flex">
                                                        <span className="bg-pink-600 text-white px-3 py-2 rounded-l-lg flex items-center">
                                                            @
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="flex-1 px-4 py-2 rounded-r-lg"
                                                            name="instagram"
                                                            value={updatedInfo.instagram}
                                                            onChange={handleInputChange}
                                                            placeholder="usuario"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Twitter */}
                                                <div>
                                                    <label className="block text-white font-medium mb-1">
                                                        Twitter / X
                                                    </label>
                                                    <div className="flex">
                                                        <span className="bg-blue-400 text-white px-3 py-2 rounded-l-lg flex items-center">
                                                            @
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="flex-1 px-4 py-2 rounded-r-lg"
                                                            name="twitter"
                                                            value={updatedInfo.twitter}
                                                            onChange={handleInputChange}
                                                            placeholder="usuario"
                                                        />
                                                    </div>
                                                </div>

                                                {/* LinkedIn */}
                                                <div>
                                                    <label className="block text-white font-medium mb-1">
                                                        LinkedIn
                                                    </label>
                                                    <div className="flex">
                                                        <span className="bg-blue-700 text-white px-3 py-2 rounded-l-lg flex items-center">
                                                            linkedin.com/in/
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="flex-1 px-4 py-2 rounded-r-lg"
                                                            name="linkedin"
                                                            value={updatedInfo.linkedin}
                                                            onChange={handleInputChange}
                                                            placeholder="usuario"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Portafolio */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Link de portafolio (opcional)
                                            </label>
                                            <input
                                                type="url"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                                name="briefcase_link"
                                                value={updatedInfo.briefcase_link ?? ""}
                                                onChange={handleInputChange}
                                                placeholder="https://..."
                                            />
                                            {alert.filter(input => input.input == "briefcase_link" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Botón de guardar */}
                                    <div className="mt-10 flex justify-center">
                                        <button
                                            type="submit"
                                            className="w-full md:w-1/2 lg:w-1/3 py-3 bg-Yellow hover:bg-amber-600 text-white font-medium rounded-lg shadow-md transition duration-300"
                                            disabled={sendingData}
                                        >
                                            {!sendingData ? (
                                                "Guardar cambios"
                                            ) : (
                                                <div className="flex items-center justify-center">
                                                    <IconLoading />
                                                    <span className="ml-2">Guardando...</span>
                                                </div>
                                            )}
                                        </button>
                                        {mensajeDeValidacion && (
                                            <div className="text-red-500 text-center mt-2">
                                                Verifica que ningún campo esté vacío!
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            }
        </>
    )
}

export default EditProfileFreelancer;